<template>
    <v-row class="ma-0 pa-0">
        <v-col md="2"></v-col>
        <v-col md="10" sm="12">
            <h1 class="headline">
                Legislative Session Housing Questionnaire
            </h1>
            <div>If you would like to offer lodging for Legislators, Pages, or Interns in Pierre or Ft. Pierre during the SD Legislative Session, please complete the following information. If you have any questions, you can contact the Legislative Research Council (LRC) at <a href="tel:(605) 773-3251" rel='noopener noreferrer'>(605) 773-3251</a> or send an email to <a rel="noopener" href="mailto:LRC@sdlegislature.gov">LRC@sdlegislature.gov</a>.</div>
            <v-form lazy-validation ref="form" v-model="valid">


                <v-text-field :counter="150" v-model="Request.EmailAddress" label="Email" :rules="emailRules" required></v-text-field>
                <v-text-field :counter="50" v-model="Request.FirstName" label="First Name"></v-text-field>
                <v-text-field :counter="50" v-model="Request.LastName" label="Last Name"></v-text-field>
                <v-text-field :counter="50" v-model="Request.Business" label="Business(if applicable)"></v-text-field>

                <v-text-field :counter="50" v-model="Request.MailingAddress" label="Mailing Address" :rules="[v => !!v || 'Required']" required></v-text-field>
                <v-text-field :counter="50" v-model="Request.MailingAddress2" label="Mailing Address 2"></v-text-field>
                <v-text-field :counter="50" v-model="Request.MailingCity" label="City" :rules="[v => !!v || 'Required']" required></v-text-field>
                <StateComponent :counter="50" v-model="Request.MailingState" label="State" :rules="[v => !!v || 'Required']" required></StateComponent>
                <v-text-field :counter="50" v-model="Request.MailingZip" label="Zip" :rules="[v => !!v || 'Required']" required></v-text-field>
                <v-text-field :counter="50" v-model="Request.PropertyAddress" label="Property Address" :rules="[v => !!v || 'Required']" required></v-text-field>
                <v-text-field :counter="50" v-model="Request.PropertyAddress2" label="Property Address 2"></v-text-field>
                <v-text-field :counter="50" v-model="Request.PropertyCity" label="City" :rules="[v => !!v || 'Required']" required></v-text-field>
                <v-text-field :counter="50" v-model="Request.PrimaryPhone" type="tel" placeholder="xxx-xxx-xxxx" v-mask="'###-###-####,######'" label="Primary Phone" :rules="primaryPhoneRules" required></v-text-field>
                <v-text-field :counter="50" v-model="Request.SecondaryPhone" type="tel" placeholder="xxx-xxx-xxxx" v-mask="'###-###-####,######'" label="Secondary Phone" :rules="secondaryPhoneRules"></v-text-field>

                <!--<div>
                    Housing Type:
                </div>-->
                <v-radio-group v-model="Request.LegislativeSessionHousingTypeId" label="Housing Type:" :rules="[v => !!v || 'Required']" required>
                    <v-radio v-for="type in housingTypes" :key="type.LegislativeSessionHousingTypeId" :label="type.LegislativeSessionHousingTypeName" :value="type.LegislativeSessionHousingTypeId"></v-radio>
                    <template v-slot:label>
                        <span style="font-size: larger; color:black">Housing Type:</span>
                    </template>
                </v-radio-group>

                <div>
                    Renter Types:(check all that apply)
                </div>
                <v-checkbox label="Check All" @click="checkAll" v-model="hostCheckAll"></v-checkbox>
                <v-checkbox label="Legislator" :error="invalidHostType" v-model="Request.HostLegislator" @click="updateHostInfo"></v-checkbox>
                <v-checkbox label="Intern" :error="invalidHostType" v-model="Request.HostIntern" @click="updateHostInfo"></v-checkbox>
                <v-checkbox label="Legislative Staff" :error="invalidHostType" v-model="Request.HostStaff" @click="updateHostInfo"></v-checkbox>
                <v-messages class="error--text" :value="['Please select at least one renter type']" v-if="invalidHostType"></v-messages>


                <v-textarea v-model="Request.Description" :rules="[v => !!v || 'Required']" required
                            label="Description: this would include number of rooms/beds/bathrooms, garage, and any other info you feel would be useful to the person searching for a place to stay. "></v-textarea>
                <v-textarea v-model="Request.Restrictions"
                            label="Restrictions: this would include such things as no smoking, no pets, if you have a preference as to the person staying (legislator, page, or intern), or any other restrictions you choose to set. "></v-textarea>
                <v-textarea v-model="Request.Comments"
                            label="Comments: this would include any additional information you feel would be helpful to potential renters (off-street parking, close to Capitol, etc.). "></v-textarea>

                <br />
                <v-checkbox label="Information may be shared with other state agencies." v-model="Request.InfoRelease"></v-checkbox>
                <br />
                <div>The SD Legislature meets during the months of January, February and part of March. Start and end dates vary from year to year. Rental prices are between you and the person renting, we do not ask for or provide that information. </div>
                <br />
                <v-btn :disabled="submitting" @click="submit()">Submit</v-btn>
                <br />
                <v-alert v-if="submitted" type="success">
                    Submitted
                </v-alert>
            </v-form>

        </v-col>
    </v-row>

</template>
<script>
    import StateComponent from '@/Components/StateComponent.vue';
    export default {
        name: 'Housing',
        components: {
            StateComponent: StateComponent
        },
        methods: {
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            checkAll() {
                this.hostCheckDirty = true;
                this.Request.HostLegislator = this.hostCheckAll;
                this.Request.HostIntern = this.hostCheckAll;
                this.Request.HostStaff = this.hostCheckAll;
                this.$forceUpdate();
            },

            updateHostInfo() {
                this.hostCheckDirty = true;
                if (!this.Request.HostLegislator || !this.Request.HostIntern || !this.Request.HostStaff) {
                    this.hostCheckAll = false;
                    this.$forceUpdate();
                }

            },
            getHousingTypes() {
                this.submitting = true
                myfetch('/api/Housing/Types', {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                .then((r) => {
                    if (r.ok) {
                        if (r.ok)
                            return r.json();
                        else
                            return r.text().then(r => Promise.reject(r));
                    }
                })
                .then((data) => {
                    this.housingTypes = data;
                })
                .catch((error) => {


                    })
                    .finally(() => {
                        this.submitting = false;
                    });

            },
            submit() {
                this.hostCheckDirty = true;
                this.submitting = true
                if (this.$refs.form.validate() && !this.invalidHostType) {
                    myfetch('/api/Housing', {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(this.Request)
                    }).then(res => {
                        if (res.ok) {
                            this.submitted = true;
                            this.hostCheckAll = false;
                            this.Request = this.blankRequest;
                            this.hostCheckDirty = false;
                            this.$refs.form.resetValidation()
                        }
                    });
                } else {
                    this.submitting = false
                }
            }
        },
        data: function () {
            return {
                submitted: false,
                submitting: false,
                search: '',
                valid: true,
                loading: false,
                hostCheckDirty: false,
                hostCheckAll: false,
                dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
                housingTypes: [],
                emailRules: [
                    v => !!v || "E-mail is required",
                    v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
                ],
                primaryPhoneRules: [
                    v => !!v || "Required",
                    v => !v || /^[0-9]{3}-[0-9]{3}-[0-9]{4}/.test(v) || 'Phone number must be valid'
                ],
                secondaryPhoneRules: [
                    v => !v || /^[0-9]{3}-[0-9]{3}-[0-9]{4}/.test(v) || 'Phone number must be valid'
                ],
                menu1: false,
                blankRequest: {
                    HousingId: 0,
                    FirstName: null,
                    LastName: null,
                    Email: null,
                    Business: null,
                    MailingAddress: null,
                    MailingAddress2: null,
                    MailingCity: null,
                    MailingState: 'SD',
                    PrimaryPhone: null,
                    SecondaryPhone: null,
                    HousingType: null,
                    Description: null,
                    Restrictions: null,
                    Comments: null,
                    HostLegislator: null,
                    HostIntern: null,
                    HostStaff: null
                },
                Request: {
                    HousingId: 0,
                    FirstName: null,
                    LastName: null,
                    Email: null,
                    Business: null,
                    MailingAddress: null,
                    MailingAddress2: null,
                    MailingCity: null,
                    MailingState: 'SD',
                    PrimaryPhone: null,
                    SecondaryPhone: null,
                    HousingType: null,
                    Description: null,
                    Restrictions: null,
                    Comments: null,
                    HostLegislator: null,
                    HostIntern: null,
                    HostStaff: null
                },
            }
        },
        mounted: function () {
            this.getHousingTypes();
        },
        watch: {
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
            },
        },
        computed: {
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
            Title: function () {
                let title = 'Housing Questionnaire';
                return title;
            },
            Description: function () {
                return this.Title;
            },
            invalidHostType() {
                return !(this.Request.HostLegislator || this.Request.HostIntern || this.Request.HostStaff) && this.hostCheckDirty
            }
        },
        metaInfo() {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0] }
                ]
            }
        }
    };
</script>
<style></style>